<div class="row agent-container">
  <div class="col-12 p-0">
    <div class="card" *ngIf="!isLoading && productList">
      <div class="card-header d-none">
        Custom Products
        <div class="card-actions">
          <button class="btn btn-white" (click)="openPop(customModal)">
            Create
          </button>          
          <button class="btn btn-white" (click)="exportProducts()">
            Export
          </button>
        </div>
      </div>

      <!-- Filter Section -->
      <div class="card-body p-0">
        <div class="card">
          <div class="card-body pl-0 pr-0 pb-0">
            <form [formGroup]="fiterForm">
              <div class="d-flex justify-content-end align-items-center hidden-xl-up filter-mobile-toolbar">
                <a
                  class="cursor-pointer btn btn-sm btn-secondary search-btn filter-toggle-btn"
                  (click)="utilService.toggleDivClass('filter-products', 'hidden-lg-down')"
                >
                  <i class="fa fa-plus"></i>
                  <i class="fa fa-minus d-none"></i>
                </a>
                <button
                  type="button"
                  class="btn btn-sm btn-white clear-btn ml-1"
                  (click)="clearFilters()"
                  ngbTooltip="Clear All Filters"
                  *ngIf="filterApplied"
                >
                  <i class="mdi mdi-filter-remove-outline"></i>
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-primary search-btn ml-1"
                  (click)="openPop(customModal)"
                  ngbTooltip="Create Product"
                >
                  <i class="mdi mdi-plus-box"></i>
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-primary search-btn ml-1"
                  (click)="exportProducts()"
                  ngbTooltip="Export Products"
                >
                  <img src="assets/images/icon/export.svg" class="text-primary" style="width: 22px;" />
                </button>
              </div>
              <div class="row filter-header hidden-lg-down" id="filter-products">
                <div class="col-12 d-xl-flex align-items-start flex-wrap">
                  <div class="col-12 col-xl-3 mb-2">
                    <label class="d-block">Product Name</label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="name"
                      (keydown.enter)="onEnterSearch()"
                      (keypress)="omit_special_char($event)"
                    />
                  </div>
                  <div class="col-12 col-xl-3 mb-2">
                    <label class="d-block">Brand</label>
                    <select class="form-control" formControlName="brand" (keydown.enter)="onEnterSearch()">
                      <option value="">All</option>
                      <option *ngFor="let status of productMaster" [value]="status.slug">
                      {{ status.name }}
                    </option>
                  </select>
                  </div>
                  <div class="col-12 col-xl-2 mb-2">
                    <label class="d-block">Category</label>
                    <select class="form-control" formControlName="subcategory" (keydown.enter)="onEnterSearch()">
                        <option value="">All</option>
                        <option *ngFor="let prod of productsCategory" [value]="prod.slug">
                        {{ prod.name }}
                      </option>
                    </select>
                    <!-- <input
                      type="text"
                      class="form-control"
                      formControlName="category"
                      (keydown.enter)="onEnterSearch()"
                      (keypress)="omit_special_char($event)"
                    /> -->
                  </div>
                  <div class="col-12 col-xl-2 mb-2">
                    <label class="d-block">Sorting</label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="order"
                      (keydown.enter)="onEnterSearch()"
                      (keypress)="omit_special_char($event)"
                    />
                  </div>
                  <!-- <div class="col-12 col-xl-3 mb-2">
                    <label class="d-block">Status</label>
                    <select
                      class="form-control custom-select"
                      formControlName="disable"
                    >
                      <option value="">All</option>
                      <option *ngFor="let status of statusTypes" [value]="status.value">
                        {{ status.text }}
                      </option>
                    </select>
                  </div> -->
                  <div class="col-12 col-xl-2">
                      <div class="form-group mb-0 d-flex align-items-end mt-4">
                        <div class="d-flex gap-1 filter-search-actions">
                          <button type="button" class="btn btn-sm btn-primary search-btn" (click)="onEnterSearch()" ngbTooltip="Search">
                            <i class="mdi mdi-magnify"></i>
                          </button>
                        </div>
                        <div class="d-none d-xl-flex gap-1 w-50 ms-auto justify-content-end">
                          <button type="button" class="btn btn-sm btn-primary search-btn ml-1" (click)="openPop(customModal)"
                            ngbTooltip="Create Product">
                            <i class="mdi mdi-plus-box"></i>
                          </button>
                          <button type="button" class="btn btn-sm btn-primary search-btn ml-1" (click)="exportProducts()"
                            ngbTooltip="Export Products">
                            <img src="assets/images/icon/export.svg" class="text-primary" style="width: 22px;" />
                          </button>
                        </div>
                      </div>
                    </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <!-- List Table -->
      <div class="card-body" [ngClass]="{ 'p-0': productList && productList.length > 0 }">
        <div class="table table-responsive smart-table" *ngIf="productList && productList.length > 0">
          <table class="w-100">
            <thead>
              <tr>
                <th>
                  <div class="sort pointer" [ngClass]="{
                      asc: sortBy === 'name' && sortDir === 1,
                      desc: sortBy === 'name' && sortDir === -1
                      }" (click)="sort('name')">Product Name
                    </div>
                  </th>
                <th>
                  <div class="sort pointer" [ngClass]="{
                      asc: sortBy === 'brand' && sortDir === 1,
                      desc: sortBy === 'brand' && sortDir === -1
                      }" (click)="sort('brand')">Brand</div>
                    </th>
                <th><div class="sort pointer" [ngClass]="{
                      asc: sortBy === 'subcategory' && sortDir === 1,
                      desc: sortBy === 'subcategory' && sortDir === -1
                      }" (click)="sort('subcategory')">
                      Category</div>
                    </th>
                <th>
                  <div class="sort pointer" [ngClass]="{
                      asc: sortBy === 'order' && sortDir === 1,
                      desc: sortBy === 'order' && sortDir === -1
                      }" (click)="sort('order')">Sorting
                    </div>
                  </th>
                <!-- <th>Status</th> -->
                <th class="text-right">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let product of productList">
                <td>{{ product.name }}</td>
                <td>{{ product.brand }}</td>
                <td>{{ getProductName(product.subcategory) }}</td>
                <td>{{ product.order }}</td>
                <!-- <td>{{ product.disable?'Disabled':'Enabled'}}</td> -->
                <td class="text-right" style="width: 100px;">
                  <a
                    class="cursor-pointer"
                    ngbTooltip="Edit"
                    (click)="openPop(customModal,product)"
                  >
                    <i class="ti-pencil text-info m-r-10"></i>
                  </a>
                  <a
                    class="ng2-smart-action ng2-smart-action-delete-delete cursor-pointer"
                    placement="top"
                    (click)="openDelete(approveModal,product._id)"
                    ngbTooltip="Delete Product"
                  >
                    <i class="ti-trash text-danger m-r-10"></i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- No Data -->
        <app-no-data-msg
          [message]="'No Custom Products Found'"
          *ngIf="productList && productList.length === 0"
        ></app-no-data-msg>
      </div>

      <!-- Pagination -->
       <div class="card-footer" *ngIf="productList && productList.length > 0">
        <div class="row">
          <div class="col-md">
            <span>{{
              utilService.showPaginationInfoNew(
                pager.Totalrecords,
                pager.perPage,
                pager.currentPage
              )
            }}</span>
          </div>
          <div class="col-sm">
            <form [formGroup]="fiterForm">
              <div class="form-group mb-0 pull-right">
                <small>Rows:</small>
                <select
                  class="form-control custom-select rows-button"
                  name="perPage"
                  (change)="onEnterSearch()"
                  formControlName="perPage"
                >
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="30">30</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
                <input
                  *ngIf="pager.TotalPages && pager.TotalPages > 1"
                  type="number"
                  #goto
                  name="goto"
                  class="form-control goto-input"
                  placeholder="Page No"
                  min="1"
                  max="{{ pager.TotalPages }}"
                />
                <span
                  *ngIf="pager.TotalPages && pager.TotalPages > 1"
                  class="btn page-goto goto-btn"
                  (click)="goPage()"
                >
                  Go
                </span>
              </div>
            </form>
          </div>
          <div class="col-md" *ngIf="pager.TotalPages && pager.TotalPages > 1">
            <div class="">
              <ul class="pagination pull-right">
                <li>
                  <a (click)="setPage(pager.currentPage - 1)"
                    ><i class="icon-arrow-left"></i
                  ></a>
                </li>
                <li
                  *ngFor="let page of PageList"
                  [ngClass]="{ active: pager.currentPage === page.page }"
                >
                  <a (click)="setPage(page.page)">{{ page.label }}</a>
                </li>
                <li>
                  <a (click)="setPage(pager.currentPage + 1)"
                    ><i class="icon-arrow-right"></i
                  ></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <app-table-loader [isLoading]="isLoading"></app-table-loader>

    <!-- Create/Edit Modal -->
    <ng-template #customModal let-modal>
      <form
        [formGroup]="customCreateForm"
        (ngSubmit)="submitGroup()"
        class="form-horizontal form-material"
        novalidate
      >
        <div class="modal-header">
          <h4 class="modal-title">
            {{ modalMode | titlecase }} Custom Product</h4>
          <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group row">
            <label class="col-12 col-xl-3">
              <app-required-indication [control]="customCreateForm.controls['name']"
                [label]="'Product Name'"></app-required-indication>
            </label>
            <div class="col-12 col-xl-9">
              <app-form-error-wrapper [apiErrorType]="'name'" [control]="customCreateForm.controls['name']"
                [controlName]="'Product name'">
                <input class="form-control" type="text" formControlName="name" />
              </app-form-error-wrapper>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-12 col-xl-3">
              <app-required-indication [control]="customCreateForm.controls['brand']"
                [label]="'Brand'"></app-required-indication>
            </label>
            <div class="col-12 col-xl-9">
              <app-form-error-wrapper [apiErrorType]="'brand'" [control]="customCreateForm.controls['brand']"
                [controlName]="'Brand'">
                <select class="form-control" formControlName="brand" (change)="onBrandChange($event.target.value)">
                  <option value="" disabled>-- Select Brand --</option>
                  <option *ngFor="let status of productMaster" [value]="status.slug">
                    {{ status.name }}
                  </option>
                </select>
              </app-form-error-wrapper>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-12 col-xl-3">
              <app-required-indication [control]="customCreateForm.controls['subcategory']"
                [label]="'Category'"></app-required-indication>
            </label>
            <div class="col-12 col-xl-9">
              <select class="form-control" formControlName="subcategory" (change)="updateCategory($event.target.value)">
                <option value="" disabled>-- Select Category --</option>
                <option *ngFor="let c of categories" [value]="c.slug">{{ c.name }}</option>
              </select>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-12 col-xl-3">
              <app-required-indication [control]="customCreateForm.controls['order']"
                [label]="'Sorting'"></app-required-indication>
            </label>
            <div class="col-12 col-xl-9">
              <app-form-error-wrapper [apiErrorType]="'order'" [control]="customCreateForm.controls['order']"
                [controlName]="'order'">
        
                <input class="form-control" formControlName="order" />
              </app-form-error-wrapper>
            </div>
          </div>
          <!-- <div class="form-group row">
            <label class="col-12 col-xl-3">
              <app-required-indication [control]="customCreateForm.controls['disable']"
                [label]="'Status'"></app-required-indication>
            </label>
            <div class="col-12 col-xl-9">
              <app-form-error-wrapper [apiErrorType]="'disable'" [control]="customCreateForm.controls['disable']"
                [controlName]="'disable'">
                <select class="form-control" formControlName="disable">
                  <option *ngFor="let status of statusTypes" [value]="status.value">
                    {{ status.text }}
                  </option>
                </select>
              </app-form-error-wrapper>
            </div>
          </div> -->
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="modal.dismiss('Cross click')">Cancel</button>
          <!-- <button type="submit" class="btn btn-primary">
            Submit
          </button> -->
          <button
          type="submit"
          class="btn btn-primary d-flex align-items-center"
          [disabled]="isLoading"
        >
          <app-button-loader
            [isLoading]="isLoading"
            [label]="'Confirm'"
          >
          </app-button-loader>
        </button>
        </div>
      </form>
    </ng-template>
    <!--approve delete-->
    <ng-template #approveModal let-modal>
      <div class="modal-header">
        <h4 class="modal-title">Confirm Delete</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        Are you sure you want to delete?
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss('Cross click')">Cancel</button>
        <!-- <button type="button" class="btn btn-primary" (click)="modal.close('confirm')">Confirm</button> -->
        <button
          type="submit"
          class="btn btn-primary d-flex align-items-center"
          [disabled]="isLoading"
        >
          <app-button-loader
            [isLoading]="isLoading"
            [label]="'Confirm'"
            (click)="modal.close('confirm')"
          >
          </app-button-loader>
        </button>
      </div>
    </ng-template>

    <div class="help-container">
      <div class="help-section">
        <p class="help-text" (click)="openHelpPopup()">
          <i class="hellp-popup-icons"></i>
        </p>
      </div>
    </div>
  </div>
</div>
